import { DateTime } from 'luxon';

export const formatDate = (dt : string) : string => (
  dt ? DateTime.fromISO(dt, { zone: 'utc' }).setZone('Europe/Rome').toFormat('f') : ''
);
export const formatDateRelative = (dt : string) : string => (
  dt ? DateTime.fromISO(dt, { zone: 'utc' }).setZone('Europe/Rome').toRelative() || '' : ''
);
